var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-viewport-switch-container"},[_c('ToggleSwitch',{attrs:{"name":"map-viewport-switch","label":_vm.$t('MAP_VIEWPORT_LIST'),"label-position":"right","value":_vm.useViewportFilter},on:{"change":_vm.onSwitchChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }